<template>
    <div id="root">
        <div class="container-fluid m-0 staticPage">
            <div class="row bg-dark">
                <nav class="navbar navbar-expand-lg navbar-dark bg-dark">
                    <a class="navbar-brand Pointer" style="font-size: 15px !important " @click="GotoLogin">سامــــــانه اینترنت بانک
                    </a> <span class="text-warning mr-3" style="font-size: 15px !important"> {{ $store.state.NameSandogh }}
                    </span>
                    <button class="navbar-toggler" type="button" data-toggle="collapse"
                        data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
                        aria-label="Toggle navigation">
                        <span class="navbar-toggler-icon"></span>
                    </button>

                    <div class="collapse navbar-collapse text-right" id="navbarSupportedContent">
                        <ul class="navbar-nav mr-auto">
                            <!-- <li class="nav-item active">
                                <a class="nav-link mx-2" href="#" style="font-size: 15px !important">اخبار <span
                                        class="sr-only">(current)</span></a>
                            </li> -->
                            <!-- <li class="nav-item mx-3">
                                <a class="nav-link Pointer" target="_blank" style="font-size: 15px !important">ارتباط با
                                    ما</a>
                            </li> -->
                            <li class="nav-item mx-3">
                                <router-link :to="{ name: 'AboutUs' }" class="nav-link Pointer" tag="a"
                                    style="font-size: 15px !important">درباره ما</router-link>
                            </li>

                        </ul>
                    </div>
                    
                </nav>
            </div>
            <net-pa-card>
              <template slot="header" >
                <div class="d-inline"><h6 class="text-right d-inline"><i class="fas fa-list-alt mx-2"></i>درباره ما</h6>
                <span class="float-left" @click="$router.go(-1)"> <i data-v-9331d9a2="" title="بازگشت به صفحه قبلی" class="fas fa-arrow-left text-light Pointer " style="float: left; font-size: 18px"></i></span></div> 

              </template>
              <template slot="content">
                <div class="d-flex justify-content-center text-right">
                <div v-html="aboutUsContent" class="mx-3">
                </div>
            </div>
              </template>
            </net-pa-card>

        </div>


    </div>
</template>

<script>
import NetPaCard from '../../Tools/NetPa/NetPaCard.vue'
export default {
    components: {NetPaCard },
    data() {
        return {
            aboutUsContent: ''
        }
    },
    created() {
        this.getAboutUs()
    },
    methods: {
        getAboutUs() {
            this.$PostData_new('WebSiteSetting/GetAboutUs', 'get').then((resp) => {
                this.aboutUsContent = resp
                // console.log("@", this.aboutUsContent);
            }).catch((err) => {
                this.$mySweetDefaultTost('عملیات ناموفق', 'خطایی رخ داد', 'error', 2000)
                console.error(err)
            })
        },
        GatImg() {
            // return './Image/U1-6.png'
            return 'background-image:url("./Image/back.jpg");background-size: cover; height: 100vh;'
        },
        GotoLogin() {
            this.$session.set('ForceLoginpage', true)
            this.$router.push({
                name: 'LoginPage',
            })
        },
        gettblCustomer() {
            this.$PostData({
                ArryfildValue: {},
                Action: 'GetTblCustomer',
                method: 'GET',
                Token: '',
            }).then((data) => {
                this.$store.state.NameSandogh = data.name
                this.$session.set('NameSandogh', data.name)
                this.$session.set('CustCode', data.custCode)
                document.title = data.name
            })
        },

    }
}

</script>

<style scoped>
.footer {
    position: fixed;
    right: 0;
    bottom: 0;
    width: 100%;
    background-color: #202020;
    color: white;
    text-align: center;
}

.staticPage {
    padding: 2%;
    min-height: 100vh !important;
    background: #fff !important;
}

h2 span {
    font-size: 70px !important;
}

h3 {
    color: white;
    font-size: 20px !important;
    margin-top: 35px;
    margin-top: 35px;
}

.bg-1 {
    background: #7e549e;
}

.bg-2 {
    background: #c2549d;
}

.bg-3 {
    background: #fc8370;
}

.bg-4 {
    background: #d4b117;
}

.Hover-Efect:hover span.fas {
    transform: rotate(30deg);
    transition: 0.5s;
    font-size: 80px !important;
    /* color: #e6063e; */
}

.Hover-Efect span.fas {
    transition: 1s;
}
</style>